import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Clock from 'react-live-clock';
import { Grid } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    rightheader: {
        float:"right",
        maxWidth: "120px",
        position:"absolute",
        top:"2px",
        right:"0",
        lineHeight: "1.25",
    },
    clock: {
        fontSize: 14,
    },
    gridItem: {
        textAlign: 'center',
    }
});

class HeaderRight extends React.Component {
    constructor(props){
        super(props);
        this.props=props;
    }

    render() {
        const { classes } = this.props;

        return (
            <Typography color="inherit" className={classes.rightheader}> 
                <Grid container spacing={0}>
                    <Grid item xs={12} className={classes.gridItem}>
                        <span>{this.props.initials}</span> 
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Clock format={'h:mm:ss a'} ticking={true} className={classes.clock}/> 
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Clock format={'ddd Do MMM'} ticking={false} className={classes.clock}/> 
                    </Grid>
                </Grid>
            </Typography>
        );
    }
}

export default withStyles(styles)(HeaderRight);
